export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5178.8c6be300.jpg";